import axios from "axios";
import { API_PATHS } from "../utils/constants/api.constants";

class Tags {
    static getTags() {
        return axios
            .get(API_PATHS.getTag)
            .then((response) => {
                if (response.data) {
                    // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }
    
    
    static uploadTags(item) {
        return axios
            .post(API_PATHS.postTag,
                item
            )
            .then((response) => {
                if (response.data) {
                     // localStorage.setItem("user", JSON.stringify(response.data));
                }
                return response.data;
            });
    }

    static removeUserDetails() {
        localStorage.removeItem("user");
    }

    static getUserDetails() {
        return JSON.parse(localStorage.getItem("user"));
    }
}

export default Tags;